<template>
  <div class="teacher-container">
    <div class="item-background"></div>
    <div class="item-container">
      <div class="left">
        <img
          class="teacher-img"
          src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/wyx.jpg"
          alt=""
        />
        <div class="bold-desc">Associate Professor</div>
        <div class="email-desc">
          lsswyx@hdu.edu.cn<br />https://wyxlss.github.io
        </div>
      </div>
      <div class="right">
        <div class="bold-title">个人介绍 INTRODUCTION</div>

        <div class="right-content">
          <p class="para">
            <strong>王宇翔</strong
            >，杭州电子科技大学计算机学院副教授，硕士生导师，杭电首批钱江学者，CCF/ACM/IEEE会员，中国中文信息学会会员，语言与知识计算专委会委员，ACM SIGCOMM China委员，
            杭电-三汇数字知识图谱联合实验室副主任，之江实验室外聘专家。2015年获东南大学工学博士学位，2019-2020年赴新加坡南洋理工大学（NTU）访学。
          </p>
          <p class="para">
            主要研究领域为<strong>图计算与学习、知识图谱查询与优化、异构网络社区查询</strong>等，主持国家自然科学基金青年/面上项目，浙江省尖兵领雁研发攻关计划项目、浙江省科技计划项目；
            参与国基金5项、浙江省重点研发项目2项，之江实验室攻关项目1项（子课题负责人），武器装备预研项目1项。已在CCF A/B类推荐会议或期刊发表论文30余篇，
            包括VLDB、ICDE、TKDD、CIKM、DASFAA、ICPP、KBS、DKE等，授权发明专利5项。曾担任TKDE、KBS、Information Science、DMKD等学术期刊评审专家，
            国家基金函评专家，IJCAI’23, KDD’23, PAKDD’20-22程序委员会委员。
          </p>
        </div>
        <div class="bold-title">科研项目 PROJECTS</div>
        <div class="right-content">
          ◎
          浙江省“尖兵”“领雁”研发攻关计划项目：“未来实验室数字化建设关键技术研究与应用示范”(2023C03198)，2023-01至2026-12，170万（在研，主持）；
          <br />◎
          国家自然科学基金面上项目：“语义驱动的知识图谱近似图查询关键技术研究”(62072149)，2021-01至2024-12，56万
          (在研，主持)；
          <br />◎
          国家自然科学基金青年项目:“面向大数据近似查询应用的在线聚集融合机制与优化研究”(61602410)，
          2017.1-2019.12，20万 (结题，主持); <br />◎
          浙江省属高校基础科研业务费项目重点培育专项：“复杂异构网络社区查询关键技术研究”，2021-01至2023-01，20万
          (在研，主持) <br />◎
          浙江省科技计划公益项目:“RDF知识图谱分布式语义近似查询关键技术研究”(LGG19F020017)，
          2019.1-2021.12，10万 (在研，主持); <br />◎
          浙江省重点研发计划项目：“重大活动公共安全智
          能防控平台开发及应用示范”(2021C03156)，2021-01至2023-12，240万
          (在研，参与)； <br />◎
          浙江省重点研发计划项目：“促进成果转化的科技大数据服务平台开发及应用”(2017C01009)，2016-07至2019-06，300万
          (已结题，参与)； <br />◎
          浙江省数字化改革重点扶持项目(之江实验室)：“未来实验室数字化管理和科研辅助工具平台”，2021-09至2022-12，800万
          (在研，参与)； <br />◎
          浙江省重点研发计划项目:”浙江省科技特派员服务云平台建设关键技术研究与示范”(2021C03156),2021-01至2023-12，800万(在研，参与);
          <br />◎
          国家社会科学基金重大项目:”基于大数据的科教评价信息云平台构建和智能服务研究”(19ZDA348),2019-12至2024-12，60万(在研，参与)。
        </div>
        <div class="bold-title">发表论文 SELECTED PUBLICATIONS</div>
        <div class="right-content">



          ◎ Yuxiang Wang, Jun Liu, Xiaoliang Xu*, Efficient and Effective Academic Expert Finding on Heterogeneous Graphs through 
          (k,P)-Core based Embedding[J], ACM Transactions on Knowledge Discovery from Data,2023,17(6): 85:1-85:35. <br />
          
          ◎ Qiang Yue, Xiaoliang Xu*, Yuxiang Wang, et al., Routing-Guided Learned Product Quantization for Graph-Based Approximate Nearest 
          Neighbor Search, International Conference on Data Engineering (ICDE, CCF A), 2024 <br />

          ◎ Mengzhao Wang, Lingwei Lv, Xiaoliang Xu*, Yuxiang Wang, Qiang Yue, Jiongkang Ni, An Efficient and Robust Framework 
          for Approximate Nearest Neighbor Search with Attribute Constraint, Conference on Neural Information Processing Systems 
          (NeurIPS, CCF A), 2023<br />
          
          ◎ Shuzhan Ye, Xiaoliang Xu, Yuxiang Wang*, Tao Fu, Efficient Complex Aggregate Queries with Accuracy Guarantee based on 
          Execution Cost Model over Knowledge Graphs, Mathematics, 2023, 11(18), 3908; DOI: 10.3390/math11183908 <br />

          ◎ Xiaoxun Gou, Xiaoliang Xu, Xiangying Wu, Runhuai Chen, Yuxiang Wang*, Tianxing Wu, Xiangyu Ke ,Effective and Efficient 
          Community Search with Graph Embeddings，ECAI 2023, Volume 372, p891-898. <br />
          

          ◎ Yuxiang Wang, Arijit Khan, Xiaoliang Xu*, Jiahui Jin, Qifan Hong,
          Tao Fu.AAggregate Queries on Knowledge Graphs: Fast Approximation with
          Semantic-aware Sampling. ICDE 2022. (CCF A)
          <br />◎ Xiaoliang Xu, Jun Liu, Yuxiang Wang*, Xiangyu Ke. Academic
          Expert Finding via (K,P)-Core based Embedding over Heterogeneous
          Graphs. ICDE 2022. (CCF A) 
          <br />◎ Yuxiang Wang, Jun Liu, Xiaoliang Xu, Xiangyu Ke, Tianxing Wu, Xiaoxuan Gou. 
          Efficient and Effective Academic Expert Finding on Heterogeneous Graphs through (k,P)-Core based Embedding. 
          Transactions on Knowledge Discovery from Data (TKDD), 2022, Accepted. (CCF B, IF=4.157)
          <br />◎ •	Xiaoliang Xu, Qifan Hong, Yuxiang Wang*, Jiahui Jin, Xinle Xuan, Tao Fu. 
          A Random Walk Sampling on Knowledge Graphs for Semantic-oriented Statistical Tasks. Data & Knowledge Engineering, 2022. (CCF B) 
          <br />◎ Mengzhao Wang, Xiaoliang Xu, Qiang
          Yue, Yuxiang Wang*. A Comprehensive Survey and Experimental Comparison
          of Graph-Based Approximate Nearest Neighbor Search. VLDB 2021. (CCF A)
          <br />◎ Yuxiang Wang, Arijit Khan, Tianxing Wu, Jiahui Jin, Haijiang
          Yan. Semantic Guided and Response Times Bounded Top-k Similarity
          Search over Knowledge Graphs. ICDE 2020: 445-456. (CCF A, acceptance
          ratio 19.5%) <br />◎ Yuxiang Wang, Xiaoliang Xu*, Qifan Hong, et al.
          Top-k Star Queries on Knowledge Graphs Through Semantic-aware Bounding
          Match Scores, Knowledge-Based Systems (KBS), 2021, Volume
          213(2):106655. (CCF B, JCR R1) <br />◎ Xiaoliang Xu, Mengzhao Wang,
          Yuxiang Wang, Dingcheng Ma. Two-Stage Routing with Optimized Guided
          Search and Greedy Algorithm on Proximity Graph. Knowledge-based
          Systems (KBS), 2021. (CCF B, JCR R1) <br />◎ Yuxiang Wang, Junzhou
          Luo, Aibo Song, Fang Dong. A Sampling-Based Hybrid Approximate Query
          Processing System in the Cloud. ICPP 2014: 291-300. (CCF B) <br />◎
          Yuxiang Wang, Junzhou Luo, Aibo Song, Jiahui Jin, Fang Dong. Improving
          Online Aggregation Performance for Skewed Data Distribution. DASFAA
          2012: 18-32. (CCF B) <br />◎ Xiaoliang Xu, Chang Li, Yuxiang Wang*, et
          al. Multiattribute Approximate Nearest Neighbor Search Based on
          Navigable Small World Graph. Concurrency and Computation:Practice and
          Experience (CCPE), 2020, 32(24). (CCF C) <br />◎ Xiaoliang Xu, Tong
          Gao, Yuxiang Wang*, et al. Event Temporal Relation Extraction with
          Attention Mechanism and Graph Neural Network. Tsinghua Science and
          Technology. (JCR R3) <br />◎ Jiahui Jin, Xiaoxuan Zhu, Biwei Wu,
          Jinghui Zhang, Yuxiang Wang. A Dynamic and Deadline-Oriented Road
          Pricing Mechanism for Urban Traffic Management. Tsinghua Science and
          Technology, 2020. (JCR R3) <br />◎ Yuxiang Wang, Junzhou Luo, Aibo
          Song, Fang Dong. OATS: online aggregation with two-level sharing
          strategy in cloud. Distributed Parallel Databases, 32(4): 467-505,
          2014. (CCF C) <br />◎ Yuxiang Wang, Junzhou Luo, Aibo Song, Fang Dong.
          Partition-Based Online Aggregation with Shared Sampling in the Cloud.
          Journal of Computer Science and Technology, 28(6): 989-1011, 2013.
          (CCF B, JCR R2) <br />◎ Yuxiang Wang, Zhangpeng Ge, Haijiang Yan,
          Xiaoliang Xu*, et al. Semantic Locality based Approximate Knowledge
          Graph Query. Concurrency and Computation:Practice and Experience
          (CCPE), 2019, 31(24):1-13. (CCF C) <br />◎ Yuxiang Wang, Jiahui Jin,
          Xiaoliang Xu*, et al. Skew-aware online aggregation over joins through
          guided sampling. Concurrency and Computation: Practice and Experience
          (CCPE), 2018, 30(20): e4695.1-e4695.17. (CCF C) <br />◎ Yuxiang Wang,
          Yixing Xia, Qiming Fang, Xiaoliang Xu*. AQP++: a hybrid approximate
          query processing framework for generalized aggregation queries.
          Journal of computational science (JOCS), 2018, 26: 419-431. (JCR R3)
        </div>
        <div class="bold-title">发明专利 PATENTS</div>
        <div class="right-content">
          ◎
          徐小良，李畅，王宇翔,一种基于可导航小世界图的多属性近似最近邻搜索方法,申请号:202010185898.X.(实审发明专利）
          <br />◎
          徐小良，马丁程，王宇翔，一种结合VP树和导向近邻图的近似最近邻搜索方法，申请号202011223218.5.(实审发明专利)
          <br />◎
          徐小良，洪启帆，王宇翔，一种语义敏感的知识图谱随机游走采样方法，申请号202010185892.2.(实审发明专利）
          <br />◎
          徐小良，颜海江，王宇翔，一种语义敏感的RDF知识图谱近似查询方法，申请号201910279900.7.(实审发明专利）
          <br />◎ 王宇翔，颜海江，徐小良，一种基于领域子图的
          RDF知识图谱存储与管理方法，申请号201910949757.8. (实审发明专利)
          <br />◎
          徐小良，穆诗棋，王宇翔，一种分布式的文本近似最近邻语义搜索计算方法，申请号201810782233.X.（实审发明专利）
          <br />◎
          徐小良，吴远超，王宇翔，一种基于专利的科技人才推荐方法，专利号：ZL201710825493.6.（授权发明专利）
          <br />◎
          徐小良，顾高飞，王宇翔，一种基于文档评分模型和相关度的学术论文搜索排序方法，专利号：ZL201710461109.9.（授权发明专利）
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.teacher-container {
  min-height: 100vh;
}
.item-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  padding-top: 60px;
}
.item-background {
  height: 60px;
}
.left {
  width: 15%;
}
.right {
  width: 85%;
  padding-left: 40px;
}
.teacher-img {
  width: 100%;
}
.bold-desc {
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  margin-top: 20px;
}
.email-desc {
  text-align: center;
  color: #03a9f4;
  font-size: 20px;
}
.bold-title {
  color: #4f81bd;
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
.right-content {
  font-size: 20px;
  line-height: 36px;
}
@media screen and (max-width: 900px) {
  .item-container {
    display: block;
  }
  .left {
    width: 100%;
    text-align: center;
  }
  .right {
    width: 100%;
  }
  .teacher-img {
    width: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/teacher/wangyuxiang.vue